










































import AssetPreview from '../AssetPreview'
import './InstagramPreview.scss'
import Vue from 'vue'
import { Asset } from '@/types/assets'

// NOTE: added ts-ignores because
// inherited property 'this.asset' keeps getting Typescript errors
// also see https://stackoverflow.com/questions/57416991/vue-typescript-how-to-avoid-ts-error-when-accessing-child-components-methods

export default Vue.extend(AssetPreview).extend({
  // alternative syntax to Vue.extend(AssetPreview):
  // extends: AssetPreview,
  name: 'InstagramPreview',
  props: {
    imageStyle: {
      type: String,
      required: false
    }
  },
  computed: {
    instagramText (): string {
      // @ts-ignore
      if (this.asset && this.asset.data && this.asset.data.text) {
        // @ts-ignore
        return this.asset.data.selectedText || this.asset.data.text
      }
      return ''
    },
    instagramHandle (): string {
      // @ts-ignore
      if (!this.asset || !this.asset.data || !this.asset.data.user) {
        return ''
      }
      // @ts-ignore
      return this.asset.data.user.name
    },
    instagramMedia (): string {
      // @ts-ignore
      if (!this.asset || !this.asset.data || !this.asset.data.media_url) {
        return ''
      }
      // @ts-ignore
      return this.asset.data.media_url
    },
    thumbnail (): string {
      // @ts-ignore
      const asset = this.asset as Asset
      return (asset.thumbnail && asset.thumbnail !== '') ? asset.thumbnail : this.instagramMedia
    },
  }
})
